// extracted by mini-css-extract-plugin
export default {"label":"Select_label__FTULT","select":"Select_select__cALRA","dropDown":"Select_dropDown__LGOwb","opened":"Select_opened__MiwL4","isInvalid":"Select_isInvalid__Evh3i"};